import axios from "axios";
import { isObject } from "__barrel_optimize__?names=isObject!=!lodash-es";
import { resFulfillIntcpt, resRejectIntcpt } from "./interceptors/response";
import { getRequestCache } from "./cache";
import { jsUrl } from "@/const";
const config = {
  baseUrl: jsUrl,
  timeout: 10000
};
const instance = axios.create({
  baseURL: config.baseUrl,
  timeout: config.timeout,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=UTF-8;"
  }
});
instance.interceptors.response.use(resFulfillIntcpt, resRejectIntcpt);
// get请求
export const get = async param => {
  let {
    url = "",
    data,
    headers = {},
    config = {}
  } = param;
  if (config.cache) {
    const cache = await getRequestCache({
      url,
      data
    });
    if (isObject(cache)) {
      return cache;
    }
  }
  return new Promise((resolve, reject) => {
    instance.get(url, Object.assign({}, data ? {
      params: data
    } : {}, {
      ...config,
      headers
    })).then(response => {
      resolve(response);
    }).catch(err => {
      reject(err);
    });
  });
};
// post请求
export const post = param => {
  let {
    url = "",
    data,
    headers = {},
    config = {}
  } = param;
  return new Promise((resolve, reject) => {
    instance.post(url, data, {
      ...config,
      headers
    }).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
};
// patch 请求
export const patch = param => {
  let {
    url = "",
    data,
    headers = {},
    config = {}
  } = param;
  return new Promise((resolve, reject) => {
    instance.patch(url, data, {
      ...config,
      headers
    }).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
};
// delete 请求
export const del = param => {
  let {
    url = "",
    headers = {},
    config = {}
  } = param;
  return new Promise((resolve, reject) => {
    instance.delete(url, {
      ...config,
      headers
    }).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
};
export const HTTP = {
  get,
  post,
  patch,
  del
};